// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__irWNH","row":"Node_row__2QrDm","label":"Node_label__1jkuN","footer":"Node_footer__1Y6FN"};